import {
  REACTION_EMOJI,
  REACTION_KINDS,
  REACTION_LABELS,
  type ReactionCounts,
  type ReactionKind,
} from '@shared/live.ts'
import { type Component, For, Show } from 'solid-js'
import { ShareButton } from '~/components/ShareButton'

type Props = {
  /** いまの番組に集まったリアクション数 */
  reactions: ReactionCounts
  onReact: (kind: ReactionKind) => void
  /** いま放送中の番組名。シェアの本文に載せる */
  programTitle?: string
  /** 全画面の帯に並べるときは、より詰めて置く */
  variant?: 'inline' | 'bar'
}

/**
 * リアクションとシェア（要件定義 17 章）。
 *
 * それだけの帯は持たせない。通常表示では NOW の見出しの脇に、
 * 全画面では上の帯に並べる。どちらでも同じ並びにして、
 * 全画面を出入りしても押す場所が変わらないようにしている。
 */
export const LiveBar: Component<Props> = (props) => {
  return (
    <div class="flex shrink-0 items-center gap-0.5">
      <For each={REACTION_KINDS}>
        {(kind) => (
          <button
            type="button"
            onClick={() => props.onReact(kind)}
            title={`${REACTION_LABELS[kind]}を送る`}
            aria-label={`${REACTION_LABELS[kind]}を送る`}
            class="inline-flex shrink-0 select-none items-center gap-1 rounded-full py-1.5 text-sm transition-transform hover:bg-ch-elevated active:scale-90"
            classList={{ 'px-1.5': props.variant === 'bar', 'px-2': props.variant !== 'bar' }}
          >
            <span aria-hidden="true">{REACTION_EMOJI[kind]}</span>
            {/* 0 のうちは数字を出さない。誰も押していないことを強調しない */}
            <Show when={props.reactions[kind] > 0}>
              <span class="hidden text-[11px] text-ch-muted tabular sm:inline">
                {props.reactions[kind].toLocaleString('ja-JP')}
              </span>
            </Show>
          </button>
        )}
      </For>

      {/* 全画面の帯は幅が足りないので、狭い画面ではシェアを畳む（通常表示には出したまま） */}
      <span
        class="ml-auto shrink-0 pl-2"
        classList={{ 'hidden sm:block': props.variant === 'bar' }}
      >
        <ShareButton
          title={props.programTitle}
          iconOnly={props.variant === 'bar'}
          class="rounded-full px-2 py-1 hover:bg-ch-elevated"
        />
      </span>
    </div>
  )
}
